<template>
  <b-col xxl="2"  >
    <div class="search-box h-100">
      <input
          type="text"
          class="form-control search h-100"
          :placeholder="$t('menu.equipment-management.search')"
          v-model="searchValue"
          @keydown="handleSearch"
      />
      <i class="ri-search-line search-icon"></i>
    </div>
  </b-col>
  <b-col xxl="2"    v-if="user&&user.user_type!=='customer'" >

    <el-select
        v-model="value"
        @change="clientChange"
        style="width: 100%; line-height: 37.5px"
        filterable
        size="large"
        :placeholder="this.$t('base.select_customer')"
        :loading="loading"
        clearable
    >
      <el-option
          v-for="option in clientName"
          :label="option['label']"
          :value="option['value']"
          :key="option.value"
      ></el-option>
      <!-- 此处加载中的value可以随便设置，只要不与其他数据重复即可 -->
      <!--                    <el-option-->
      <!--                      v-if="hasMore"-->
      <!--                      disabled-->
      <!--                      label="加载中..."-->
      <!--                      value="-1"-->
      <!--                    ></el-option>-->
    </el-select>
  </b-col>
  <b-col xxl="2"    v-if="user&&user.user_type!=='customer'">

    <el-select
        v-model="value1"
        @change="maintenanceServiceProviderChange"
        @focus="serviceCompany"
        filterable
        clearable
        style="width: 100%; line-height: 37.5px"
        size="large"
        :placeholder="this.$t('page.tending.select_service_provider')"
    >
      <el-option
          v-for="option in maintenanceServiceProvider"
          :label="option['label']"
          :value="option['value']"
          :key="option.value"
      ></el-option>
    </el-select>
  </b-col>
  <b-col xxl="2" class="d-flex justify-content-between align-items-center"  >
    <p class="search-title mb-0">
      {{ `${this.$t('page.create_time')}:` }}
    </p>
    <div style="width:100%" class="position-relative h-100">
      <flat-pickr
          :placeholder="$t('base.select-date')"
          v-model="dateValue"
          :config="config"
          @onChange="selectDate"
          @on-close="selectDateClose"
          class="form-control flatpickr-input h-100"
      >
      </flat-pickr>
      <span v-if="dateValue" @click="clearDate" class="multiselect-clear-icon position-absolute cursor-pointer" style="bottom: 26%; right:1rem;"></span>
    </div>
  </b-col>
  <b-col xxl="2" class="d-flex justify-content-between align-items-center"   v-if="user&&user.user_type!=='customer'">
    <p class="search-title mb-0">
      {{ `${this.$t('menu.equipment-management.QrcodeBinding')}:` }}
    </p>
    <div  style="width:100%" class="position-relative">
      <el-select
          v-model="is_qrcode_bind"
          @change="isQrcodeBindChange"
          filterable
          style="width: 100%; line-height: 37.5px"
          size="large"
          :placeholder="this.$t('page.select_is_qrcode_bind')"
      >
        <el-option
            v-for="(option, index) in qrcodeBindOptions"
            :label="option['label']"
            :value="option['value']"
            :key="index"
        ></el-option>
      </el-select>
    </div>
  </b-col>
</template>
<script>
import _ from "lodash";
import { getCustomers, getCompany } from "@/helpers/common-service";

export default {
  emits: ["update:tableData","initData"],
  components: {

  },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    searchDefault: {
      type: Object,
      default: () => {
        return {
          keyword: "",
          service_company: "",
          customer: "",
          created_time: "",
          is_qrcode_bind: "",
        };
      },
    },
    //二维码选择项
    qrcodeOptions:{
      type:Object,
      default: () => {
        return {};
      },
    }
    // originData: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
  },
  data() {
    return {
      searchValue: this.searchDefault.keyword,
      maintenanceServiceProvider: [],
      clientName: [],
      keyword: "", // 存储关键字用
      loading: false,
      hasMore: false,
      page: 1,
      value:this.searchDefault.customer,
      value1: this.searchDefault.service_company,
      dateValue: this.searchDefault.dateValue,
      is_qrcode_bind: this.searchDefault.is_qrcode_bind,
      searchDate: '',
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
        clearButton: true,
      },
      oldSelectedDates: [],
      // qrcodeBindOptions: [
      //   {
      //     label: this.$t('page.all'),
      //     value: undefined,
      //   },
      //   {
      //     label: this.$t('menu.equipment-management.Bound'),
      //     value: 1,
      //   },
      //   {
      //     label: this.$t('menu.equipment-management.NotBound'),
      //     value: 0,
      //   }
      // ]
    };
  },
  watch: {
    searchDefault: {
      handler(val) {
        this.searchValue = val.keyword;
        this.value = val.customer;
        this.value1 = val.service_company;
        this.dateValue = val.created_time;
        this.searchDate = this.dateValue
        this.is_qrcode_bind = val.is_qrcode_bind
        // if (this.is_qrcode_bind === undefined) {
        //   this.is_qrcode_bind = ''
        // }
      },
      deep: true,
    }
  },
  mounted() {
    console.log(this.config)
    this.getValues()
    // this.$nextTick(() => {
    //   this.initScrollEventListener();
    // });
  },
  computed:{
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    qrcodeBindOptions(){
      return [
        {
          label: this.$t('page.all'),
          value: undefined,
        },...this.qrcodeOptions
      ]
    }
  },
  methods: {
    clearDate() {
      this.dateValue = null
      this.searchDate = ''
      this.$emit('initData',{
        keyword:this.searchValue,
        service_company: this.value1,
        customer: this.value,
        created_time: '',
        is_qrcode_bind: this.is_qrcode_bind,
      })
    },
    selectDate(selectedDates) {
      if (selectedDates.length > 1 && this.diffDates(selectedDates, this.oldSelectedDates)) {
        this.oldSelectedDates = _.cloneDeep(selectedDates)
        this.searchDate = selectedDates

        this.$emit('initData',{
          keyword:this.searchValue,
          service_company: this.value1,
          customer: this.value,
          created_time: this.searchDate,
          is_qrcode_bind: this.is_qrcode_bind,
        })
      }
    },
    selectDateClose(selectedDates) {
      if (selectedDates.length < 2) {
        if (this.oldSelectedDates.length > 0) {
          this.$emit('initData', {
            keyword: this.searchValue,
            service_company: this.value1,
            customer: this.value,
            created_time: '',
            is_qrcode_bind: this.is_qrcode_bind,
          })
        }

        this.oldSelectedDates = []
      }
    },
    diffDates(dates1, dates2) {
      if (dates1.length !== dates2.length) {
        return true
      }

      let result = false
      for (var i = 0; i < dates1.length; i++) {
        console.log(dates1[i].getTime(), dates2[i].getTime(), dates1[i].getTime() !== dates2[i].getTime())
        if (dates1[i].getTime() !== dates2[i].getTime()) {
          result = true
        }
      }

      return result
    },
    // initScrollEventListener() {
    //   const SELECTWRAP = document.querySelector(
    //     ".el-select-dropdown .el-select-dropdown__wrap"
    //   );
    //   if (!SELECTWRAP) {
    //     throw new Error('无法找到 "el-select-dropdown__wrap" 节点');
    //   }
    //   SELECTWRAP.addEventListener("scroll", () => {
    //     const CONDITION =
    //       SELECTWRAP.scrollHeight -
    //       Math.ceil(SELECTWRAP.scrollTop) <=
    //       SELECTWRAP.clientHeight;
    //     if (CONDITION && SELECTWRAP.scrollTop !== 0) {
    //       this.loadMore()
    //     }
    //   });
    // },
    clientChange(){
      this.$emit('initData',{
        keyword:this.searchValue,
        service_company: this.value1,
        customer: this.value,
        created_time: this.searchDate,
        is_qrcode_bind: this.is_qrcode_bind,
      })
    },
    maintenanceServiceProviderChange(){
      this.$emit('initData',{
        keyword:this.searchValue,
        service_company:this.value1,
        customer:this.value,
        created_time: this.searchDate,
        is_qrcode_bind: this.is_qrcode_bind,
      })
    },
    isQrcodeBindChange() {
      this.$emit('initData',{
        keyword:this.searchValue,
        service_company:this.value1,
        customer:this.value,
        created_time: this.searchDate,
        is_qrcode_bind: this.is_qrcode_bind,
      })
    },
    // 请求下一页的数据
    // loadMore() {
    //   // 如果没有更多数据，则不请求
    //   if (!this.hasMore) {
    //     return;
    //   }
    //   if (this.loading) {
    //     return;
    //   }
    //   this.customers({
    //     page: ++this.page,
    //     keyword: this.keyword,
    //   })
    // },
    // 选中下拉框没有数据时，自动请求第一页的数据
    // focus() {
    //   if (!this.clientName.length) {
    //     this.customers({ page: 1 });
    //   }
    // },
    // handleSearchs(keyword) {
    //   this.keyword = keyword;
    //   this.loading = true;
    //   this.page = 1;
    //   this.customers({ page: this.page, keyword: keyword });
    // },
    customers() {
      getCustomers()
          .then((res) => {
            res.map((a) => {
              this.clientName.push({
                label: a.name,
                value: a.id,
                key: a.id + "",
              });
            });
            this.hasMore = false
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getValues() {
      getCompany()
          .then((res) => {
            this.maintenanceServiceProvider = [];
            res.map((a) => {
              this.maintenanceServiceProvider.push({
                label: a.name,
                value: a.id,
                key: a.id + "",
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
      this.page = 1;
      this.customers({ page: this.page })
    },
    serviceCompany() {
      getCompany()
          .then((res) => {
            this.maintenanceServiceProvider = [];
            res.map((a) => {
              this.maintenanceServiceProvider.push({
                label: a.name,
                value: a.id,
                key: a.id + "",
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
    },
    handleSearch(e) {
      if (e.keyCode == 13) {
        e.cancelBubble = true;
        e.stopPropagation();
        e.preventDefault();

        // let tableData = _.cloneDeep(this.originData);
        if (this.searchValue != "") {
          // console.log(tableData);
          this.$emit('initData',{
            keyword:this.searchValue,
            service_company:this.value1,
            customer:this.value,
            created_time: this.searchDate,
            is_qrcode_bind: this.is_qrcode_bind,
          })
          //   let list = tableData.filter((item) => {
          //     console.log(
          //       _.get(item, ["name"]),
          //       _.get(item, ["设备厂商"], ""),
          //       _.get(item, ["出厂编号"], ""),
          //       _.get(item, ["设备所在区域"], ""),
          //       _.get(item, ["机组名称"], ""),
          //       _.get(item, ["安装日期"], ""),
          //       _.get(item, ["质保截止日期"], ""),
          //       _.get(item, ["设备状态"], ""),
          //       _.get(item, ["设备资产编码"], "")
          //     );
          //     return (
          //       _.get(item, ["name"], "")
          //         .replace(/\s*/g, "")
          //         .toUpperCase()
          //         .includes(this.searchValue.replace(/\s*/g, "").toUpperCase()) ||
          //       _.get(item, ["设备厂商"], "")
          //         .replace(/\s*/g, "")
          //         .toUpperCase()
          //         .includes(this.searchValue.replace(/\s*/g, "").toUpperCase()) ||
          //       _.get(item, ["出厂编号"], "")
          //         .replace(/\s*/g, "")
          //         .toUpperCase()
          //         .includes(this.searchValue.replace(/\s*/g, "").toUpperCase()) ||
          //       _.get(item, ["设备所在区域"], "")
          //         .replace(/\s*/g, "")
          //         .toUpperCase()
          //         .includes(this.searchValue.replace(/\s*/g, "").toUpperCase()) ||
          //       _.get(item, ["机组名称"], "")
          //         .replace(/\s*/g, "")
          //         .toUpperCase()
          //         .includes(this.searchValue.replace(/\s*/g, "").toUpperCase()) ||
          //       _.get(item, ["安装日期"], "")
          //         .replace(/\s*/g, "")
          //         .toUpperCase()
          //         .includes(this.searchValue.replace(/\s*/g, "").toUpperCase()) ||
          //       _.get(item, ["质保截止日期"], "")
          //         .replace(/\s*/g, "")
          //         .toUpperCase()
          //         .includes(this.searchValue.replace(/\s*/g, "").toUpperCase()) ||
          //       _.get(item, ["设备状态"], "")
          //         .replace(/\s*/g, "")
          //         .toUpperCase()
          //         .includes(this.searchValue.replace(/\s*/g, "").toUpperCase()) ||
          //       _.get(item, ["设备资产编码"], "")
          //         .replace(/\s*/g, "")
          //         .toUpperCase()
          //         .includes(this.searchValue.replace(/\s*/g, "").toUpperCase())
          //     );
          //   });
          //   this.$emit("update:tableData", list);
        } else {
          this.$emit('initData',{
            keyword:this.searchValue,
            service_company:this.value1,
            customer:this.value,
            created_time: this.searchDate,
            is_qrcode_bind: this.is_qrcode_bind,
          })
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search-title {
  word-break: keep-all;
}
</style>
